"use strict";
exports.formatRelative = void 0;

const formatRelativeLocale = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) => {
  return formatRelativeLocale[token];
};
exports.formatRelative = formatRelative;
